import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectsRefactoredService } from '../../../services/Projects/projects-refactored.service';
import { Project360Service } from '../../../modules/p-dashboard/project360.service';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-share-link-dialog',
  templateUrl: './share-link-dialog.component.html',
  styleUrls: ['./share-link-dialog.component.scss'],
})
export class ShareLinkDialogComponent {
  currentLink: string;
  recipientEmail: string = '';
  copySuccess: boolean = false; // To show success message after copying link
  emailError: boolean = false;
  shareForm: FormGroup;
  emails: string[] = []; // Array to store the emails

  // To show error message if email is invalid

  constructor(
    private dialogRef: MatDialogRef<ShareLinkDialogComponent>,
    private clipboard: Clipboard,
    private toaster: ToastrService,
    private translateService: TranslocoService,
    private _projectServiceRefactored: ProjectsRefactoredService,
    private _project: Project360Service,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { link: string },
  ) {
    this.currentLink = data.link; // Injected current project link
    this.shareForm = this.fb.group({
      link: [window.location.href], // pre-fill the current project link
      email: [
        '',
        [
          Validators.email,
          Validators.pattern(/^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
        ],
      ], // email with validation
    });
  }

  // Add email to the list
  addEmail() {
    const email = this.shareForm.value.email.trim();
    if (this.emails.length === 5) {
      this.toaster.warning(
        this.translateService.translate('Sorry the maximum allowed number of emails is 5'),
      );
      return;
    } else if (this.emails.includes(email)) {
      this.toaster.warning(this.translateService.translate('This email is already added before'));
      return;
    }
    if (this.isValidEmail(email)) {
      this.emailError = false;
      this.emails.push(email); // Add email to the list
      this.shareForm.patchValue({ email: '' }); // Clear input field
    } else {
      this.emailError = true;
    }
  }

  // Copy link to clipboard
  copyLink(): void {
    this.clipboard.copy(this.currentLink);
    this.copySuccess = true; // Show success message
  }

  // Handle email sending logic
  sendEmail(): void {
    if (!this.emails.length) {
      this.toaster.warning(this.translateService.translate('Please add one email at least '));
      return;
    }
    const FORM_BODY = new FormData();
    FORM_BODY.append(`url`, this.currentLink);
    this.emails.forEach((email, index) => {
      FORM_BODY.append(`emails[${index}]`, email);
    });

    this._projectServiceRefactored.shareProjectLinks(this._project.id, FORM_BODY).subscribe(
      (res) => {
        if (res) {
          this.toaster.success(this.translateService.translate('Emails sent successfully'));
        }
      },
      (error) => {
        error.error.errors.forEach((error) => {
          this.toaster.error(error);
        });
      },
    );

    this.dialogRef.close(); // Close dialog after sending
  }

  // Basic email validation function
  emailsList: any[];
  isValidEmail(email: string): boolean {
    const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  // Remove email from the list
  removeEmail(email: string) {
    this.emails = this.emails.filter((e) => e !== email); // Remove email from the list
  }
}
